import React from "react";
import moment from "moment-timezone";
import "./Footer.css";

class Footer extends React.Component {
  render() {
    return (
      <footer className="app-footer">
        <div className="app-footer__copyright">
          ©Copyright {moment().format("YYYY")} <b>SMART MONITOR CORP.</b> - All
          Rights Reserved
        </div>
        <div className="app-footer__powered">
          <span className="app-footer__powered-text">Powered By</span>
          <img
            src="/images/acuma_logo.png"
            alt="Acuma"
            className="app-footer__logo"
          />
        </div>
      </footer>
    );
  }
}

export default Footer;
